import translate from './translate.js';

/**
 * Templates for ProductCompareBanner component
 */

const COMPARE_ITEM_LIMIT = 5;

/**
 * Generates the error message template
 *
 * @param {string} errorName The name of the error
 * @returns {string} HTML template for the error message
 */
export const renderErrorTemplate = (errorName) => {
  let message;

  switch (errorName) {
    case 'ItemLimitError':
      message = translate('maxarticlereached', COMPARE_ITEM_LIMIT + 1, COMPARE_ITEM_LIMIT);
      break;
    case 'InvalidItemTypeError':
      message = translate('badarticletype');
      break;
    default:
      message = translate('default');
      break;
  }

  return `<p class="f-alert f-alert--error f-alert--icon" aria-live="polite" id="compare-checkbox-error">${message}</p>`;
};

/**
 * Generates a placeholder item template
 *
 * @param {number} number The position number (1-5)
 * @returns {string} HTML template for an empty item placeholder
 */
export const renderItemPlaceholder = (number) => `
  <li class="f-compareItem f-compareItem--empty" aria-hidden="true" data-placeholder-number="${number}" data-automation-id="comparator-banner-item-empty"></li>`;

/**
 * Generates a compare item template
 *
 * @param {object} item The item data
 * @returns {string} HTML template for a compare item
 */
export const renderItem = (item) => {
  const itemContent = item.Inactive
    ? `<span class="f-compareItem__link" data-automation-id="comparator-banner-item">
        <img class="f-compareItem__image" src="${item.imageSrc}" alt="${item.name}" width="47" height="47" loading="lazy" data-automation-id="comparator-banner-item-image">
        <span class="f-compareItem__name" data-automation-id="comparator-banner-item-name">${item.name}</span>
      </span>`
    : `<a class="f-compareItem__link" href="${item.link}" data-automation-id="comparator-banner-item">
        <img class="f-compareItem__image" src="${item.imageSrc}" alt="${item.name}" width="47" height="47" loading="lazy" data-automation-id="comparator-banner-item-image">
        <span class="f-compareItem__name" data-automation-id="comparator-banner-item-name">${item.name}</span>
      </a>`;

  return `<li class="f-compareItem">
    <input type="hidden" name="products" value="${item.catalog}-${item.prid}">
    ${itemContent}
    <button class="f-compareItem__close js-removeCompareItem" type="button" title="Retirer du comparateur" aria-label="Retirer du comparateur" data-prid="${item.prid}" data-catalog="${item.catalog}" data-type="${item.type || 'product'}" data-automation-id="comparator-banner-item-button-close"></button>
  </li>`;
};
